import { Component, OnInit } from '@angular/core';
declare var $: any;
import { ApiService } from '.././api.service';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  arre: any;
  show = false;
  add: any = false;
  update: any = false;
  delete: any = false;
  name: any;
  email: any;
  password: any;
  adress: any;
  root: any = undefined;
  phone: any;
  control: any = undefined;
  idDU: any;
  rootA: any;
  controlA: any;
  nameU: any;
  emailU: any;
  passwordU: any;
  adressU: any;
  rootU: any;
  phoneU: any;
  controlU: any;
  idUp: any;
  searchName: any;
  rootSearch = 'Search By Root';
  controlSearch = 'Search By Permission';
  typeEmployee: any;
  controlSelectType: any = undefined;
  city: any;

  constructor(private _ApiService: ApiService , private _Router: Router, private _AppComponent: AppComponent ) {
    this._AppComponent.activeU = 'active';
    this._AppComponent.activeR = '';
    this._AppComponent.activeS = '';
    this._AppComponent.activeI = '';
    this._AppComponent.activeC = '';
    this._AppComponent.activeP = '';
    this._AppComponent.activeCu = '';
    this._AppComponent.activeCR = '';
    this._AppComponent.activeH = '';
    this._AppComponent.activeO = '';
    this._AppComponent.activeCE = '';
    this._AppComponent.activeCV = '';
    this._AppComponent.activeSE = '';
    this._AppComponent.activeSEB = '';
    this._AppComponent.activeCuO = '';
    this._AppComponent.activeCuOStore = '';
    this._AppComponent.activeHRE = '';
    this._AppComponent.activeHReport = '';
    this._AppComponent.activeCVV = '';
    this._AppComponent.activeCVEm = '';
    this._AppComponent.activeCVEmAttendances = '';
    this._AppComponent.activeCVEmAttendancesSalary = '';
    this._AppComponent.activeCVEmPermession = ''
    this._AppComponent.activeHReportAccounts = '';
    this._AppComponent.activeHReportCashPayments = '';
    this._AppComponent.activeCashReceipts = '';
    this._AppComponent.activeDailyRestrictions = '';
    this._AppComponent.activeGeneralReports = '';
    this._AppComponent.activeHReportPrivate = '';
    this._AppComponent.activeHReportPrivatePaymentsReport = '';
    this._ApiService.getControlsTypeEmployee().subscribe((res)=>{
      this.typeEmployee = res;
      this.ngOnInit();
    })
    this._ApiService.getRoots().subscribe((res)=>{
      this.rootA = res;
      this.ngOnInit();
    })
    this._ApiService.getControls().subscribe((res)=>{
      this.controlA = res;
      this.ngOnInit();
    })

    this._ApiService.Profile().subscribe((res)=>{
      if(res.check === true) {
        res.data.forEach((element: any) => {
          if(element.name == 'Users') {
            if(element.	add_permission === 1) {
              this.add = true;
            }
            if(element.	update_permission === 1) {
              this.update = true;
            }
            if(element.	delete_permission === 1) {
              this.delete = true;
            }
          }

        });
        this._AppComponent.refreshNotification()
        this.show = true;
      } else {
        this._Router.navigate([''])
        this.show = false;
      }
    })
    this._ApiService.allUsers().subscribe((res)=>{
      if(res.check === true){
        this.arre = res.data;
        this.ngOnInit();
        $('.loading').css({display: 'none'});
      } else{
        alert('error')
      }
    })
    this._AppComponent.goProfile();

   }
   closeUp(){
    $('#upd-up').css({display: 'none'});
    this.nameU = '';
    this.emailU = '';
    this.passwordU = '';
    this.phoneU = '';
    this.adressU = '';
    this.controlU = '';
    this.idUp = '';
    this.rootU = '';
    $('.rootSelectU').val('');
    $('.controlSelectU').val('');
  }
  upP(data: any){
    this.nameU = data.name;
    this.emailU = data.email;
    this.passwordU = data.password;
    this.phoneU = '0' + data.phone;
    this.adressU = data.adress;
    this.idUp = data.id;
    this.controlU = data.control;
    this.rootU = data.root;
    $('#upd-up').css({display: 'block'});
    $('.rootSelectU').val(data.root).trigger('change.select2');
    $('.controlSelectU').val(data.control).trigger('change.select2');
      }
  okUp(data: any){
    if(this.passwordU == '' || $('.rootSelectU').val() == '' || $('.controlSelectU').val() == '' || this.passwordU == undefined || this.nameU == undefined || this.nameU == '' || $('.rootSelectU').val() === undefined || $('.controlSelectU').val() === undefined ) {
      alert('Please . Make sure the name , the password, the Branch, and the Permission are entered');
    } else {
      $('.loading').css({display: 'block'});
    this._ApiService.updateUser({nameU: this.nameU, emailU: this.emailU, passwordU: this.passwordU, phoneU: this.phoneU, adressU: this.adressU , id: this.idUp, controlU: $('.controlSelectU').val(), rootU: $('.rootSelectU').val()}).subscribe((res)=> {
      if(res === true) {
        this._ApiService.allUsers().subscribe((res)=>{
          this.arre = res.data;
          // alert('Updated Done Successfully');
          this.closeUp();
        $('.loading').css({display: 'none'});
        })
      } else {
        alert("Updated Don't Successfully");
        this.closeUp();
        $('.loading').css({display: 'none'});
      }
    })
    }
  }
   delU(id: any){
    $('#upd-dd').css({display: 'block'});
    this.idDU = id;
  }
  closedd(){
    $('#upd-dd').css({display: 'none'});
    this.idDU = '';
  }
  ok(){
    $('.loading').css({display: 'block'});
    var x = this.idDU;
    this._ApiService.delU({id: x}).subscribe((res)=>{
      if(res === true){
        this._ApiService.allUsers().subscribe((res)=>{
          this.arre = res.data;
          alert('Deleted Done Successfully');
          this.closedd();
          $('.loading').css({display: 'none'});
        })
      } else {
        alert('Deleted Not Successfully\nPlease, if you want to delete this user, you must delete all his pre request on the site');
        this.closedd();
        $('.loading').css({display: 'none'});
      }
    })
  }
  addUser(){
    $('#upd').css({display: 'block'});
  }
  close(){
    $('#upd').css({display: 'none'});
    this.name = '';
    this.email = '';
    this.password = '';
    this.adress = '';
    this.root = '';
    this.phone = '';
    this.control = '';
    this.city = '';
    $('.rootSelect').val('undefined').trigger('change.select2');
    $('.controlSelect').val('undefined').trigger('change.select2');
    $('.controlSelectType').val('undefined').trigger('change.select2');
  }
  addUser0(data: any){
    if(this.password == '' || $('.rootSelect').val() == '' || $('.controlSelect').val() == '' || this.password == undefined || $('.rootSelect').val() == undefined || $('.controlSelect').val() == undefined || this.name == undefined || this.name == '' || $('.controlSelectType').val() == undefined || $('.controlSelectType').val() == '' ) {
      alert('Please . Make sure the password, the Branch, The Type , and the Permission are entered');
    } else {
      $('.loading').css({display: 'block'});
      data.root = $('.rootSelect').val();
      data.control = $('.controlSelect').val();
      data.type = $('.controlSelectType').val();
    this._ApiService.addUser(data).subscribe((res)=>{
      if(res.check === true){
        this._ApiService.allUsers().subscribe((res0)=>{
          if(res0.check === true){
            this.arre = res0.data;
            // alert('Added successfully');
            this.close();
            $('.loading').css({display: 'none'});
          } else{
            alert('error');
          }
        })
      } else {
        alert('This user already exists');
        this.close();
        $('.loading').css({display: 'none'});
      }
    })
    }
  }
  printert(){
    window.print();
  }


  ngOnInit(): void {
    // setTimeout(() => {
      $('.select2, .js-example-basic-multiple').select2();
    // }, 500);
  }

}
